import { Injectable } from '@angular/core';
import {
  Account,
  Accounting,
  Customer,
  Expense,
  ProductServiceItem,
  SalesReceipt,
  salesTax,
  Vendor,
} from '../../models/accounting';
import { Master, AccountingOptions } from '../../models/company';
import { AutoPurchase, BoundBookEntry, InventoryAlert, NicsReceived, PurchaseHistory } from '../../models/general';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class DummyDataService {
  constructor() { }

  nics: NicsReceived = {
    ntn: '103K654Y7',
    ffl_rds_key: '98202610',
    date_created: '01/07/2025 07:28 PM',
    date_transfer: '01/11/2025',
    date_expiration: '02/06/2025',
    name_last: 'SPIKER',
    name_middle: 'LARRY',
    name_first: 'SAM',
    cadence: 'Not Supplied',
    gender: 'M',
    height: 511,
    weight: 200,
    race_ethnicity: 'W',
    date_birth: '04/14/1982',
    place_of_birth: 'ID',
    upin: 'Not Supplied',
    miscellaneous_no: 'DL-VA119773Z',
    miscellaneous_field: 'Not Supplied',
    state_of_residence: 'ID',
    citizenship_status: 'C',
    country_of_citizenship: 'US',
    country_of_citizenship2: 'Not Supplied',
    country_of_citizenship3: 'Not Supplied',
    purpose_id: '1',
    submitted_by: 'brian.d.patterson',
    retrieved_by: 'brian.d.patterson',
    date_retrieved: '01/07/2025 07:28 PM',
    status: 'Proceed',
    date_status: '01/07/2025 07:28 PM',
  }

  account_information: Master = {
    company_id: null,
    company: {
      company_id: '123456789',
      company_name: 'Company 2',
      legal_name: 'Legal Name 2',
      ein: '12-3456789',
      company_logo: null,
      address: '123 Main St',
      address2: 'Suite 1',
      city: 'City',
      state: 'State',
      zip_code: '12345',
      phone_number: '123-456-7890',
      company_email: 'company2@example.com',
      customer_facing_email: 'support2@example.com',
      website: 'www.example.com',
      ffl: '1-23-456-78-9A-01234',
      ffl_expiration_date: '2023-12-31',
      ffl_document: null,
      sot_document: null,
      ffl_document_meta: null,
      sot_document_meta: null,
      users: [
        {
          user_id: '2',
          name_first: 'Jane',
          name_last: 'Doe',
          username: 'janedoe',
          password: 'password123',
          role: 'admin',
          position_title: 'sales',
        },
      ],
      autofill_form_3310: {
        agency_name: 'ADA COUNTY SHERIFFS',
        address: '7200 BARRISTER DR',
        city: 'BOISE',
        state: 'IDAHO',
        agency_email: 'sheriff@adacounty.id.gov',
        atf_email: 'multiplehandgunsalesforms@atf.gov'
      },
      email_templates: {},
      change_log: [
        {
          change_date_time: '2022-01-01T00:00:00Z',
          change_type: 'Created',
          change_to: 'Company 2',
          change_from: null,
          change_by: 'Jane Doe',
        },
      ],
      payment_types: [],
      live_inv_selected_distributors: [],
      distributor_configs: [],
      accounting_options: new AccountingOptions(),
      onboarding_dismissed: false,
    },
    firearm_list: [],
    ffl_list: [],
    bound_book: [],
    accounting: {
      expense_records: [],
      sales_records: [],
      products_services: [],
      payment_accounts: [],
      payment_methods: [],
      categories: [],
      inventory_asset_accounts: [],
      vendors: [],
      income_expense_accounts: [],
      customers: [],
      sales_tax_options: [],
    },
  };
  inventory_alerts: InventoryAlert[] = [
    {
      company_id: '6779614ed587365307a23755',
      alert_selected_vendors: ['RSR Group', `Lipsey's`],
      alert_desired_qty: 10,
      alert_item_upc: '123456789012',
      alert_item_name: 'Product 1',
      alert_item_description: 'Product 1 description',
      alert_text_number: '1234567890',
      alert_email: 'alert1@example.com',
      created_date: '01-01-2023',
      requestor: 'John Doe'
    },
    {
      company_id: '6779614ed587365307a23755',
      alert_selected_vendors: [`Davidson's`],
      alert_desired_qty: 20,
      alert_item_upc: '987654321098',
      alert_item_name: 'Product 2',
      alert_item_description: 'Product 2 description',
      alert_text_number: '0987654321',
      alert_email: 'alert2@example.com',
      created_date: '02-01-2023',
      requestor: 'Jane Smith'
    },
    {
      company_id: '6779614ed587365307a23755',
      alert_selected_vendors: ['Chattanooga Shooting Supply', `Lipsey's`],
      alert_desired_qty: 15,
      alert_item_upc: '112233445566',
      alert_item_name: 'Product 3',
      alert_item_description: 'Product 3 description',
      alert_text_number: '5555555555',
      alert_email: 'alert3@example.com',
      created_date: '03-01-2023',
      requestor: 'Alice Johnson'
    }
  ]
  auto_purchase: AutoPurchase[] = [
    {
      company_id: '6779614ed587365307a23755',
      auto_purchase_selected_vendors: [`RSR Group`, `Lipsey's`],
      auto_purchase_desired_qty: 10,
      auto_purchase_item_upc: '123456789012',
      auto_purchase_item_name: 'Product 1',
      auto_purchase_item_description: 'Product 1 description',
      auto_purchase_starting_date: '01-01-2023',
      auto_purchase_ending_date: '01-31-2023',
      auto_purchase_partial_orders_allowed: true,
      created_date: '01-01-2023',
      requestor: 'John Doe'
    },
    {
      company_id: '6779614ed587365307a23755',
      auto_purchase_selected_vendors: [`Davidson's`],
      auto_purchase_desired_qty: 20,
      auto_purchase_item_upc: '987654321098',
      auto_purchase_item_name: 'Product 2',
      auto_purchase_item_description: 'Product 2 description',
      auto_purchase_starting_date: '02-01-2023',
      auto_purchase_ending_date: '02-28-2023',
      auto_purchase_partial_orders_allowed: false,
      created_date: '02-01-2023',
      requestor: 'Jane Smith'
    },
    {
      company_id: '6779614ed587365307a23755',
      auto_purchase_selected_vendors: [`Chattanooga Shooting Supply`, `Lipsey's`],
      auto_purchase_desired_qty: 15,
      auto_purchase_item_upc: '112233445566',
      auto_purchase_item_name: 'Product 3',
      auto_purchase_item_description: 'Product 3 description',
      auto_purchase_starting_date: '03-01-2023',
      auto_purchase_ending_date: '03-31-2023',
      auto_purchase_partial_orders_allowed: true,
      created_date: '03-01-2023',
      requestor: 'Alice Johnson'
    }
  ]
  auto_purchase_history: PurchaseHistory[] = [
    {
      company_id: '6779614ed587365307a23755',
      purchase_date: '01-01-2023 12:34:00',
      vendor_name: `RSR Group`,
      item_upc: '123456789012',
      item_name: 'Auto Part A',
      item_description: 'Description for Auto Part A',
      desired_qty: 10,
      purchase_qty: 10,
      item_price: 15.99,
      purchase_total: 159.90,
      order_number: 'ORD001'
    },
    {
      company_id: '6779614ed587365307a23755',
      purchase_date: '02-15-2023 01:26:00',
      vendor_name: `Lipsey's`,
      item_upc: '234567890123',
      item_name: 'Auto Part B',
      item_description: 'Description for Auto Part B',
      desired_qty: 5,
      purchase_qty: 5,
      item_price: 25.50,
      purchase_total: 127.50,
      order_number: 'ORD002'
    },
    {
      company_id: '6779614ed587365307a23755',
      purchase_date: '03-10-2023 03:14:00',
      vendor_name: `RSR Group`,
      item_upc: '345678901234',
      item_name: 'Auto Part C',
      item_description: 'Description for Auto Part C',
      desired_qty: 20,
      purchase_qty: 20,
      item_price: 9.99,
      purchase_total: 199.80,
      order_number: 'ORD003'
    },
    {
      company_id: '6779614ed587365307a23755',
      purchase_date: '04-05-2023 16:44:00',
      vendor_name: `Davidson's`,
      item_upc: '456789012345',
      item_name: 'Auto Part D',
      item_description: 'Description for Auto Part D',
      desired_qty: 7,
      purchase_qty: 7,
      item_price: 30.00,
      purchase_total: 210.00,
      order_number: 'ORD004'
    },
    {
      company_id: '6779614ed587365307a23755',
      purchase_date: '05-20-2023 11:33:00',
      vendor_name: `Lipsey's`,
      item_upc: '567890123456',
      item_name: 'Auto Part E',
      item_description: 'Description for Auto Part E',
      desired_qty: 12,
      purchase_qty: 12,
      item_price: 12.50,
      purchase_total: 150.00,
      order_number: 'ORD005'
    }
  ]
  dummyDrafts = [
    // Draft 1: Only firearms selected
    {
      id: uuidv4(),
      timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
      data: {
        reserved_firearms: [
          { firearm_id: '1', firearm: 'Glock 19', serial_number: 'GLK12345' },
          { firearm_id: '2', firearm: 'AR-15', serial_number: 'AR67890' },
        ],
        transferee_4473: {
          id: '5',
          name_first: '',
          name_last: '',
          birth_month: '',
          birth_day: '',
          birth_year: '',
        },
        drivers_license: {
          nameFirst: 'Michael',
          nameLast: 'Brown',
          licenseNumber: '',
        },
        seller_4473_created: false,
        pdf_reviewed_signed: false,
      },
      activeStep: 0,
    },
    // Draft 2: Firearms and Buyer's 4473 selected
    {
      id: uuidv4(),
      timestamp: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
      data: {
        reserved_firearms: [
          {
            firearm_id: '3',
            firearm: 'Smith & Wesson M&P Shield',
            serial_number: 'SW45678',
          },
        ],
        transferee_4473: {
          id: '4',
          name_first: 'Jane',
          name_last: 'Doe',
          birth_month: '05',
          birth_day: '15',
          birth_year: '1990',
        },
        drivers_license: {
          nameFirst: 'Jane',
          nameLast: 'Doe',
          licenseNumber: '',
        },
        seller_4473_created: false,
        pdf_reviewed_signed: false,
      },
      activeStep: 1,
    },
    // Draft 3: Steps 1-3 complete
    {
      id: uuidv4(),
      timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
      data: {
        reserved_firearms: [
          {
            firearm_id: '4',
            firearm: 'Sig Sauer P320',
            serial_number: 'SIG98765',
          },
        ],
        transferee_4473: {
          id: '3',
          name_first: 'John',
          name_last: 'Smith',
          birth_month: '03',
          birth_day: '22',
          birth_year: '1985',
        },
        drivers_license: {
          nameFirst: 'John',
          nameLast: 'Smith',
          licenseNumber: 'DL123456789',
        },
        seller_4473_created: false,
        pdf_reviewed_signed: false,
      },
      activeStep: 2,
    },
    // Draft 4: Steps 1-4 complete
    {
      id: uuidv4(),
      timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
      data: {
        reserved_firearms: [
          {
            firearm_id: '5',
            firearm: 'Ruger 10/22',
            serial_number: 'RUG54321',
          },
        ],
        transferee_4473: {
          id: '1',
          name_first: 'Alice',
          name_last: 'Johnson',
          birth_month: '11',
          birth_day: '08',
          birth_year: '1992',
        },
        drivers_license: {
          nameFirst: 'Alice',
          nameLast: 'Johnson',
          licenseNumber: 'DL987654321',
        },
        seller_4473_created: true,
        pdf_reviewed_signed: false,
      },
      activeStep: 3,
    },
    // Draft 5: Steps 1-5 complete
    {
      id: uuidv4(),
      timestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
      data: {
        reserved_firearms: [
          {
            firearm_id: '6',
            firearm: 'Remington 870',
            serial_number: 'REM13579',
          },
          {
            firearm_id: '7',
            firearm: 'Colt 1911',
            serial_number: 'COLT24680',
          },
        ],
        transferee_4473: {
          id: '2',
          name_first: 'Bob',
          name_last: 'Wilson',
          birth_month: '07',
          birth_day: '14',
          birth_year: '1988',
        },
        drivers_license: {
          nameFirst: 'Bob',
          nameLast: 'Wilson',
          licenseNumber: 'DL555666777',
        },
        seller_4473_created: true,
        pdf_reviewed_signed: true,
      },
      activeStep: 4,
    },
  ];
}
